export default "__VITE_ASSET__Dn1JwQGY__"